import { GetRequest, PostRequestJson, PutRequestJson } from "src/shared/api";
import { config } from "src/config/config";

export const getCurrentAccountInfoAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.current_account}`;
  const data = {
    user_currency: options.userCurrency,
  };
  return GetRequest(url, data, {});
};

export const updateCurrentAccountInfoAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.current_account}`;
  const data = {
    username: options.username,
    email: options.email,
    first_name: options.firstName,
    last_name: options.lastName,
  };
  return PutRequestJson(url, data, {});
};

export const getUserPointsAPI = () => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.point_details}`;

  return GetRequest(url, null, {});
};

export const getUserTradeOfferHistoriesAPI = () => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.trade_offer_histories}`;

  return GetRequest(url, null, {});
};

export const getUserPointBalanceAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.point_balance}`;
  const data = {
    asset_token_id: options.assetTokenId,
  };

  return GetRequest(url, data, {});
};

export const getShowingMenuSettingsAPI = () => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.showing_menu_settings}`;

  return GetRequest(url, null, {});
};
